export default __webpack_public_path__ + "static/media/wee_logo.7b876e59.svg";